import styled from "styled-components";
import { hexToRgba } from "../../../../themes/colorUtils";

export const Wrap = styled.div`
  position: sticky;
  top: 70px;
  z-index: 35;
  background: ${(p) => hexToRgba(p.theme.tokens.colors.bg, 0.94)};
  backdrop-filter: blur(10px);
  border-bottom: 1px solid ${(p) => p.theme.tokens.colors.line};
  padding: 12px 0;
`;

export const Inner = styled.div`
  position: relative;
  max-width: 1180px;
  margin: 0 auto;
  padding: 0 28px;
`;

export const ChipsRow = styled.div`
  display: flex;
  gap: 9px;
  overflow-x: auto;
  scroll-behavior: smooth;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const Chip = styled.button<{ $active: boolean }>`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 9px;
  padding: 9px 18px 9px 12px;
  border-radius: 999px;
  border: none;
  cursor: pointer;
  font-weight: 800;
  font-size: 14px;
  white-space: nowrap;
  transition: all 0.15s;
  font-family: ${(p) => p.theme.tokens.font.family};
  background: ${(p) => (p.$active ? p.theme.tokens.gradients.button : p.theme.tokens.colors.surface)};
  color: ${(p) => (p.$active ? p.theme.tokens.colors.surface : "#41524D")};
  box-shadow: ${(p) => (p.$active ? "0 6px 16px rgba(14, 122, 102, 0.28)" : "0 1px 5px rgba(16, 32, 27, 0.06)")};
`;

export const ChipIconBadge = styled.span<{ $active: boolean }>`
  display: inline-flex;
  width: 28px;
  height: 28px;
  border-radius: 9px;
  align-items: center;
  justify-content: center;
  background: ${(p) => (p.$active ? "rgba(255, 255, 255, 0.22)" : p.theme.tokens.colors.softTeal)};
  color: ${(p) => (p.$active ? p.theme.tokens.colors.surface : p.theme.tokens.colors.teal)};
`;

export const RailArrow = styled.button<{ $side: "left" | "right" }>`
  position: absolute;
  top: 0;
  bottom: 0;
  ${(p) => (p.$side === "left" ? "left: 0;" : "right: 0;")}
  width: 40px;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: ${(p) => (p.$side === "left" ? "flex-start" : "flex-end")};
  background: ${(p) => {
    const bg = p.theme.tokens.colors.bg;
    const direction = p.$side === "left" ? "90deg" : "270deg";
    return `linear-gradient(${direction}, ${bg} 40%, ${hexToRgba(bg, 0)})`;
  }};
  color: ${(p) => p.theme.tokens.colors.ink};
`;
